import React from 'react';
import './Header.css';
import { Link } from 'react-router-dom';
// import SignInButton from '../SignInButton/SignInButton'; // adjust path if needed
// import SignOutButton from '../Signout/Signout';
import Image from '../Assets/home.png'
import AuthToggleButton from '../swap/AuthToggleButton';

function Header() {
  return (
    <header className="header">
      <Link to="/" style={{ textDecoration: "none", color: "#ddd" }}>
        <div className='logo'><img src={`${Image}`} alt='logo'/>
        {/*<h1>Entrease</h1>*/}</div>
      </Link>
      <div className='sign'>
       <AuthToggleButton /></div>
    </header>
  );
}

export default Header;
